export enum Experiment {
  EnableDatePickerStyling = 'specs.myAccount.EnableDatePickerStyling',
  EnableLoginAndAddressInTextsTab = 'specs.myAccount.EnableLoginAndAddressInTextsTab',
  EnableAllSubdivisionsInAddressForm = 'specs.myAccount.EnableAllSubdivisionsInAddressForm',
  EnableHtmlTagSettings = 'specs.myAccount.EnableHtmlTagSettings',
  EnableE164PhoneValidation = 'enableE164PhoneValidationForAccountDataUpdate',
  EnableNewThumbnailSkins = 'enableNewThumbnailSkinsForMembersAreaPanels',
}
